<div *transloco="let t" class="flex flex-col gap-1">
  <p class="text-sm font-medium text-text-primary">
    {{ t('Emplacement') }}
  </p>
  <p class="mb-1 text-sm text-text-tertiary">
    {{
      t(
        'Les membres des groupes sélectionnés pourront consulter le télésuivi et rejoindre la conversation à tout moment.'
      )
    }}
  </p>
  <div [formGroup]="form">
    <pxc-department-picker
      data-testid="department-picker"
      [clientCode]="clientCode"
      [departmentIds]="departmentIds"
      [isClientChoiceDisabled]="true"
      (departmentIdsChange)="setDepartmentIds($event)">
      <tui-error formControlName="departmentIds" />
    </pxc-department-picker>
  </div>
</div>
